import * as React from "react";
import { TextField, TextFieldWidth } from "azure-devops-ui/TextField";
import { ObservableValue } from "azure-devops-ui/Core/Observable";

const multilineObservable = new ObservableValue<string>("");

export default class MultiLineTextFieldExample extends React.Component<any, any> {
    public render(): JSX.Element {
        return (
            <TextField
                ariaLabel="Aria label"
                value={multilineObservable}
                onChange={(e, newValue) => (multilineObservable.value = newValue)}
                multiline
                rows={4}
                width={TextFieldWidth.standard}
            />
        );
    }
}
